import * as types from "../constants/actionTypes";
import * as Tools from "../helpers/Tools";

export const dashboardInitialState = {
    dcjSelfOrderOptOutConfirm: false,
    hasSeenMembershipNotification: false,
    isMyChartInActive: false,
    isShowAllUsers: null,
    videoVisitLinks: null
};


export default function dashboardReducer(state = dashboardInitialState, action) {
    switch (action.type) {
        case types.LOAD_DASHBOARD_START:
            return { ...state, error: false, isFetching: true, todosWaiting: true, isEpicDashboardError: false };
        case types.LOAD_DASHBOARD_SUCCESS:
            return { ...state, isFetching: action.isWaiting, dashBoardDetails: action.dashBoardData, isEpicDashboardError: false };
        case types.LOAD_DASHBOARD_ERROR:
            return { ...state, isEpicDashboardError: true };
        case types.TODOS_SUCCESS:
            return { ...state, todosWaiting: action.isWaiting, todos: action.todos, todosError: null };
        case types.TODOS_FAILURE:
            return { ...state, todosWaiting: false, todosError: action.error };
        //case types.AJAX_CALL_ERROR:
        //    debugger;
        //    return { ...state, isFetching: false, error: action.error };
        case types.USER_LOGGED_OUT:
            //debugger;
            return { ...dashboardInitialState, error: action.errorCode };
        case types.GET_EPIC_LETTERS_SUCCESS:
            return { ...state, letters: action.letters, isLetterSuccess: true, lettersError: null };
        case types.GET_EPIC_LETTERS_FAILURE:
            return { ...state, letters: null, isLetterSuccess: false, lettersError: action.error };
        case types.LOAD_BFF_DASHBOARD_PENDING:
            return {
                ...state, bffDashboardData: { ...state.bffDashboardData, isWaiting: true, error: null, success: false }
            };
        case types.LOAD_BFF_DASHBOARD_SUCCESS:
            if (action.bffDashboardData && action.bffDashboardData.visits && action.bffDashboardData.visits.length > 0) {
                const visits = [...action.bffDashboardData.visits];

                const appointments = visits && visits.length > 0 && visits.map((acc, index) => {

                    if (acc.appointmentDateTime && acc.patientInternalId) {
                        return {
                            ...acc, appointmenttimes: Tools.getCentralDateWithFormat(acc.appointmentDateTime, "LT"),
                            appointmentEcheckinDays: Tools.differenceInDays(acc.appointmentDateTime),
                            appointmentDateTimeForDisplay: Tools.getCentralDateWithFormat(acc.appointmentDateTime, "MMM DD"),
                            appointmentTimeZone: Tools.getCentralDateWithFormat(acc.appointmentDateTime, 'z'),
                            patientInternalId: acc.patientInternalId.trim(),
                        }
                    }
                    return acc;
                });
                action.bffDashboardData.appointments = appointments;
            }

            let membershipNotification = null;
            if (!state.hasSeenMembershipNotification) {
                membershipNotification = action.bffDashboardData?.filteredMembershipNotifications
            }
            return {
                ...state, isMyChartInActive: action.bffDashboardData.isMyChartInActive, bffDashboardData: { ...state.bffDashboardData, isWaiting: false, data: action.bffDashboardData, membershipNotification: membershipNotification, error: null, success: true }
            };
        case types.LOAD_BFF_DASHBOARD_FAILURE:
            return {
                ...state, bffDashboardData: { isWaiting: false, data: null, error: true, success: false }
            };
        case types.SET_MEMBERSHIP_NOTI_RESPONSE:
            return {
                ...state, hasSeenMembershipNotification: true, bffDashboardData: { ...state.bffDashboardData, membershipNotification: null }
            }
        //case types.DCJ_SELF_ORDER_FAILURE:
        //    return { ...state, dcjSelfOrderSuccess: false, dcjSelfOrderPending: false, dcjSelfOrderFailure: true };
        //case types.DCJ_SELF_ORDER_PENDING:
        //    return { ...state, dcjSelfOrderSuccess: false, dcjSelfOrderPending: true };
        //case types.DCJ_SELF_ORDER_SUCCESS:
        //    return { ...state, dcjSelfOrderSuccess: true, dcjSelfOrderPending: false, dcjSelfOrderFailure: false };


        //case types.DCJ_SELF_ORDER_OPTOUT_FAILURE:
        //    return { ...state, dcjSelfOrderOptOutSuccess: false, dcjSelfOrderOptOutPending: false, dcjSelfOrderOptOutFailure: true };
        //case types.DCJ_SELF_ORDER_OPTOUT_PENDING:
        //    return { ...state, dcjSelfOrderOptOutSuccess: false, dcjSelfOrderOptOutPending: true };
        //case types.DCJ_SELF_ORDER_OPTOUT_SUCCESS:
        //    return { ...state, dcjSelfOrderOptOutSuccess: true, dcjSelfOrderOptOutPending: false, dcjSelfOrderOptOutFailure: false, dcjSelfOrderOptOutConfirm: true };
        //case types.UPDATE_DCJ_SELF_ORDER_OPTOUT_CONFIRM:
        //    return { ...state, dcjSelfOrderOptOutConfirm: action.confirm };
        case types.GET_VIDEO_VISIT_LINK:
            let videoVisitLinks = state.videoVisitLinks ? state.videoVisitLinks : [];
            if (action && action.csn) {
                videoVisitLinks[action.csn] = {
                    waitingOnVideoVisitLink: true
                }
            }
            return { ...state, videoVisitLinks };
        case types.GET_VIDEO_VISIT_LINK_SUCCESS:
            let tempVideoVisitLinks = state.videoVisitLinks;
            if (action && action.videoVisitLink && action.videoVisitLink.csn) {
                tempVideoVisitLinks[action.videoVisitLink.csn] = {
                    ...action.videoVisitLink, waitingOnVideoVisitLink: false
                };
            }
            return { ...state, videoVisitLinks: tempVideoVisitLinks};
        case types.GET_VIDEO_VISIT_LINK_FAILURE:
            let tempvideoVisitLinksError = state.videoVisitLinks;
            if (action && action.csn) {
                tempvideoVisitLinksError[action.csn] = {
                    ...action.error, waitingOnVideoVisitLink: false
                }
            }
            return { ...state, videoVisitLinks: tempvideoVisitLinksError};
        case types.GET_VIDEO_VISIT_LINK_RESET:
            return { ...state, videoVisitLinks: null };
        case types.LOAD_DASHBOARD_SEE_ALL_VIEW:
            return { ...state, isShowAllUsers: true };
        case types.RESET_DASHBOARD_SEE_ALL_VIEW:
            return { ...state, isShowAllUsers: false };
        case types.INITIAL_STATE_DASHBOARD_SEE_ALL_VIEW:
            return { ...state, isShowAllUsers: null };
        case types.DISCOVER_TILE_DISMISS_SUCCESS:
            console.info(`dashboardReducer DISCOVER_TILE_DISMISS_SUCCESS state, action`, state, action);
            const tile = action.tile;
            let tiles = [...state.bffDashboardData.data.userAppTiles.tiles];
            let tileIdx = tiles.map(t => { return t.tileId; }).indexOf(tile.tileId);
            tiles.splice(tileIdx, 1);
            //const newtiles = tiles.filter(t => { return t.itemId != tile.tileId });
            const returnState = {
                ...state, bffDashboardData: {
                        ...state.bffDashboardData, data: {
                            ...state.bffDashboardData.data, userAppTiles: {
                                ...state.bffDashboardData.data.userAppTiles, tiles: tiles
                            }
                        }
                    }
            };
            return {...returnState}
        default:
            return { ...state };

    }
}